import type { Message } from '../api/types'

/**
 * A message with nothing to draw (1.20.1).
 *
 * No text, no media, no card of any kind, and not deleted: `Bubble` renders
 * an empty row for it -- every branch there hangs on text, an attachment or
 * a card. Such rows exist: the migration text of the highlights update said
 * `ON DELETE CASCADE` for `media.highlight_id` where the schema says
 * `SET NULL`, and a database that followed it lost the shared photo of a
 * post when the point made from it was deleted. The post stayed, empty,
 * and got a day divider over nothing -- from use, with a screenshot.
 *
 * The server keeps the row (a hole in the history would tear the paging);
 * the page treats it like a deleted one. One place for the question, so
 * the list, the unread edge and the divider agree.
 */
export function istLeer(m: Message): boolean {
  return (
    !m.deleted
    && m.body === ''
    && m.media.length === 0
    && (m.highlights?.items.length ?? 0) === 0
    && m.poll === null
    && (m.weather ?? null) === null
    && (m.day_card ?? null) === null
  )
}
